var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _rect2, _rect3, _path8, _path9, _circle, _rect4, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "work-from-home",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ea348b",
    d: "M57,30v5H49v6H36V34H31V30a4,4,0,0,1,4-4H53A4,4,0,0,1,57,30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0d0b4",
    d: "M47,17v9a3,3,0,0,1-6,0V17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecc19c",
    d: "M42.5,22a5.33,5.33,0,0,1-1.5-.21v2a5.33,5.33,0,0,0,1.5.21A5.472,5.472,0,0,0,47,21.66v-2A5.472,5.472,0,0,1,42.5,22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0d0b4",
    d: "M51,12v2a1,1,0,0,1-1,1H48V11h2A1,1,0,0,1,51,12Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6a563d",
    d: "M48,9H33a6,6,0,0,1,6-6,5.935,5.935,0,0,1,3.4,1.06c.2-.02.4-.06.6-.06A5,5,0,0,1,48,9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5e0cd",
    d: "M37,9H48a0,0,0,0,1,0,0v7.5A5.5,5.5,0,0,1,42.5,22h0A5.5,5.5,0,0,1,37,16.5V9A0,0,0,0,1,37,9Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 33,
    y: 35,
    fill: "#f0d0b4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5e0cd",
    d: "M55,35V46H33V41a2.006,2.006,0,0,1,2-2h4l1,2h9V35Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 10,
    x: 5,
    y: 51,
    fill: "#957856"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 5,
    x: 3,
    y: 46,
    fill: "#a78966"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00d7df",
    d: "M52,10V26H47V20l-.05-.28L45,9H37v7.5a5.57,5.57,0,0,0,.44,2.17L33,16V10a6,6,0,0,1,6-6h7A6,6,0,0,1,52,10Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#9bfbff",
    d: "M27,28V42H6V28a2.006,2.006,0,0,1,2-2H25A2.006,2.006,0,0,1,27,28Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 34,
    r: 2,
    fill: "#ffda44"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 4,
    x: 6,
    y: 42,
    fill: "#898890"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61,45H56V36h1a1,1,0,0,0,1-1V30a5,5,0,0,0-5-5V10a7.008,7.008,0,0,0-7-7H39a7.008,7.008,0,0,0-7,7v6a1,1,0,0,0,.48.86l4.2,2.52A6.556,6.556,0,0,0,40,22.5V25H35a5,5,0,0,0-5,5v4a1,1,0,0,0,1,1h1v6H28V28a3.009,3.009,0,0,0-3-3H8a3.009,3.009,0,0,0-3,3V45H3a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1H4v9a1,1,0,0,0,1,1H59a1,1,0,0,0,1-1V52h1a1,1,0,0,0,1-1V46A1,1,0,0,0,61,45ZM36,9v7.5c0,.05.01.09.01.14L34,15.43V10a5,5,0,0,1,5-5h7a5,5,0,0,1,5,5V25H48V20a1.1,1.1,0,0,0-.02-.18l-2-11A1,1,0,0,0,45,8H37A1,1,0,0,0,36,9ZM46,21.97V26a2,2,0,0,1-4,0V22.97a4.193,4.193,0,0,0,.5.03A6.487,6.487,0,0,0,46,21.97ZM38,16.5V10h6.17l1.71,9.45A4.488,4.488,0,0,1,38,16.5ZM32,30a3.009,3.009,0,0,1,3-3h5.14a3.983,3.983,0,0,0,7.72,0H53a3.009,3.009,0,0,1,3,3v4H48V33H46v2a1,1,0,0,0,1,1h1v4H40.62l-.73-1.45A.977.977,0,0,0,39,38H37.53l-.5-2,.94-3.76-1.94-.48L35.72,33H32Zm3.03,6.24L35.47,38H35a3,3,0,0,0-1,.18V35h1.22l-.19.76A.975.975,0,0,0,35.03,36.24ZM35,40h3.38l.73,1.45A.977.977,0,0,0,40,42h9a1,1,0,0,0,1-1V36h4v9H34V41A1,1,0,0,1,35,40ZM7,28a1,1,0,0,1,1-1H25a1,1,0,0,1,1,1V41H7ZM7,43H32v2H7ZM58,60H6V52H58Zm2-10H4V47H60Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15,31a3,3,0,1,0,3,3A3,3,0,0,0,15,31Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,15,35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.bd3989c8d7701a1d0d89758a58bc57ed.svg";
export { ForwardRef as ReactComponent };